module.exports = __webpack_public_path__ + "static/media/font-adjustment-decrease.db96d997.svg";